import React from "react";
import Navbar from "../Navbar";
import SecondNavbar from "../SecondNavbar";
import { Link, Outlet } from "react-router-dom";
import Footer from "../Footer";
import Breadcrumbs from "../Partials/Breadcrumbs";
import { useSelector } from "react-redux";

function Layout() {
  const token = useSelector((state) => state.dropdown.token);

  return (
    <>
      <div className="bg-[#EAEFFB] h-full">
        <div className="border-b bg-[#FFFFFF]">
          <Navbar />
        </div>
        <SecondNavbar />
        <Breadcrumbs />
        <div className="relative container max-w-7xl mx-auto">
          <Outlet />
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Layout;
